import { createSelector } from "@reduxjs/toolkit";
import type { RoomValidationDiffItem } from "@backend/src/shared/schemas/room/roomValidationSchema";

type ValidationDiffInput = {
  diffItems: RoomValidationDiffItem[];
  onlyDeviations: boolean;
};

const selectDiffItems = (input: ValidationDiffInput) => input.diffItems;
const selectOnlyDeviations = (input: ValidationDiffInput) => input.onlyDeviations;

export const selectValidationDiffItems = createSelector(
  [selectDiffItems, selectOnlyDeviations],
  (items, onlyDeviations): RoomValidationDiffItem[] =>
    onlyDeviations ? items.filter((item) => item.delta !== 0) : items
);
